export default "<script type=\"text/x-mustache-template\" data-tag-name=\"span\">\n  {{{title}}}\n</script>";